export const WEBSITE_EVENTS = {
  /** 网站生成完成 */
  GENERATION_COMPLETED: 'websiteGenerationCompleted',
  /** 网站产物交付失败 */
  GENERATION_FAILED: 'websiteGenerationFailed',
  /** 构建状态变更 */
  BUILD_STATUS_CHANGE: 'buildStatusChange',
  /** 预览就绪 */
  PREVIEW_READY: 'previewReady',
  /** 部署完成 */
  DEPLOY_FINISHED: 'deployFinished',
  /** 快捷指令 */
  SHORTCUT_SUGGESTION: 'shortcutSuggestion',
  /** 项目版本创建 */
  PROJECT_VERSION_CREATED: 'projectVersionCreated',
  /** 队列消息开始消费 */
  QUEUE_ITEM_STARTED: 'queueItemStarted',
  /** 队列消息处理完成 */
  QUEUE_ITEM_COMPLETED: 'queueItemCompleted',
  /** 队列消息处理失败 */
  QUEUE_ITEM_FAILED: 'queueItemFailed',
  /** 数据库实例状态变更 */
  DATABASE_INSTANCE_STATUS: 'databaseInstanceStatus',
  /** 项目标题变更 */
  PROJECT_TITLE_UPDATED: 'projectTitleUpdated',
  /** 项目源码变更 */
  PROJECT_SOURCE_CHANGED: 'projectSourceChanged',
  /** 沙盒页面刷新 */
  WEBSITE_REFRESH: 'websiteRefresh',
} as const;
